'use client'
import { usePathname } from 'next/navigation'
import { ComponentType } from 'react'
import { Game, GameState } from 'types'
import Button from './ui-other/basic/Button'

interface ToCurrentGameButtonProps {
  games: Game[]
  classNames?: string
}

export const ToCurrentGameButton: ComponentType<ToCurrentGameButtonProps> = ({
  games,
  classNames = 'mb-8'
}) => {
  const pathName = usePathname()

  const currentGameIndex = games.findIndex(
    (game) =>
      (game.state === GameState.LIVE || game.state === GameState.PRE) &&
      new Date() < new Date(game.startsAt)
  )

  const breakpoint =
    typeof window !== 'undefined' && window.innerWidth <= 768 ? 5 : 7

  const showButton =
    games.length >= breakpoint &&
    currentGameIndex > breakpoint - 1 &&
    currentGameIndex !== -1 &&
    pathName !== '/spiele-des-tages'

  console.log(
    'tocurrent',
    showButton,
    games.length,
    breakpoint,
    currentGameIndex
  )

  //   const date = new Date(games[currentGameIndex]?.startsAt)
  //     .toISOString()
  //     .split('T')[0]

  if (!showButton) {
    return null
  }

  const id = games[currentGameIndex].id

  const toDiv = (gameId: string) => {
    const gameElement = document.getElementById(gameId)
    const headerNav = document.getElementById('layout-header')
    const top = (gameElement?.offsetTop ?? 0) - (headerNav?.clientHeight ?? 0)
    window.scrollTo({ top: top })
  }

  return (
    <div className={classNames}>
      <Button
        className="btn-blue btn-short ticker-nav-item"
        color="gray"
        onClick={() => toDiv(id)}
      >
        zum aktuellen Spiel
      </Button>
    </div>
  )
}
